import { useLayoutEffect, useRef } from 'react';

const FUNC_KEY = Symbol('FUNC_KEY');

/**
 * Возвращаем одну и туже ссылку на функцию, но выполняется последняя переданная функция
 */
const useConstFunc = f => {
	const { current } = useRef((...args) => current[FUNC_KEY]?.(...args));
	current[FUNC_KEY] = f;
	return current;
};

/**
 * Возвращаем одну и туже ссылку на функцию, но выполняется последняя переданная функция.
 * Обновление функции откладывается до фазы выполниения эфектов (commit phase)
 */
const useConstHandler = f => {
	const { current } = useRef((...args) => (current[FUNC_KEY] ?? f)?.(...args));

	// отложить момент присвоения функции до фазы выполниения эфектов (commit phase)
	useLayoutEffect(() => {
		current[FUNC_KEY] = f;
	});

	return current;
};

export { useConstFunc, useConstHandler };
